import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import toast from "react-hot-toast";
import "../../assets/css/Customermodalbox.css";
import SelectCustomer from "./SelectCustomer";
import { getCheckoutProcess } from "../../features/checkout/service/CheckoutProcess.service";

function Proceedcheckout({ checkoutId, cartType = "fresh" }) {
  const [show, setShow] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
  };
const handleProceed = async () => {
  if (!selectedCustomer) {
    alert("Please select customer");
    return;
  }

  const payload = {
    cart_type: "fresh",
    customer_id: selectedCustomer.id,
    loyalty_points: Number(selectedCustomer.loyalty_points || 0),
  };

  console.log(payload);

  setLoading(true);

  const response = await getCheckoutProcess(
    checkoutId,
    payload
  );

  setLoading(false);

  if (response) {
    handleClose();
    window.location.href = "/summary";
  } else {
    alert("Checkout Failed");
  }
};
  return (
    <>
      <Button
        className="btn btn-primary-yellow mb-1"
        onClick={handleShow}
      >
        Proceed Checkout
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Body>

              <SelectCustomer
                  selectedCustomer={selectedCustomer}
                  onChange={setSelectedCustomer}
              />
              
          <div className="d-flex justify-content-end">

            <Button
              variant="secondary"
              onClick={handleClose}
            >
              Close
            </Button>

            <Button
              className="ms-2"
              style={{
                background: "#ff935c",
                color: "#222"
              }}
              disabled={loading}
              onClick={handleProceed}
            >
              {loading ? "Processing..." : "Proceed"}
            </Button>

          </div>

        </Modal.Body>
      </Modal>
    </>
  );
}

export default Proceedcheckout;